/*
 * Ki-Tax: System for the management of external childcare subsidies
 * Copyright (C) 2017 City of Bern Switzerland
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {TSBetreuungsmitteilungPensum} from './TSBetreuungsmitteilungPensum';
import {TSMitteilung} from './TSMitteilung';

export class TSBetreuungsmitteilung extends TSMitteilung {
    private _betreuungspensen: Array<TSBetreuungsmitteilungPensum>;
    private _applied: boolean;
    private _errorMessage: string;

    public constructor() {
        super();
    }

    public get betreuungspensen(): Array<TSBetreuungsmitteilungPensum> {
        return this._betreuungspensen;
    }

    public set betreuungspensen(value: Array<TSBetreuungsmitteilungPensum>) {
        this._betreuungspensen = value;
    }

    public get applied(): boolean {
        return this._applied;
    }

    public set applied(value: boolean) {
        this._applied = value;
    }

    public get errorMessage(): string {
        return this._errorMessage;
    }

    public set errorMessage(value: string) {
        this._errorMessage = value;
    }
}
